// Copyright (c) StrangeBee 2023

import React, { useCallback } from 'react';
import { ReactElement } from 'react';
import ExternalLink from '@Atoms/ExternalLink/ExternalLink';
import { useGenericQuery } from '@Queries/genericQueries';
import { StatusOutput } from 'thehive-sdk';
import client from '@Client';

import './LoginSiderText.scss';

export const LoginSiderText = (): ReactElement => {
    const { data: dataStatus } = useGenericQuery<StatusOutput>({
        fetchOnStart: true,
        manual: true,
        retry: false,
        key: ['status-public'],
        fetchCallback: useCallback(() => client.StatusController.get('public'), []),
    });

    return (
        <div className="login-sider-text">
            <div className="login-sider-text__version">{dataStatus?.version}</div>

            <div className="login-sider-text__copyright">
                Copyright © 2023{' '}
                <ExternalLink title="StrangeBee" url="https://www.strangebee.com/">
                    StrangeBee
                </ExternalLink>
            </div>
        </div>
    );
};
